module.exports = __webpack_public_path__ + "img/ic_nav_info_white.08673a12.svg";